module.exports = __webpack_public_path__ + "media/configurations/SV_X-O-571633f9.png";